export const ERROR_MESSAGE = {
  VALIDATION: {
    EMAIL: "정확한 이메일 양식을 입력해 주세요.",
    NAME: "한글 또는 영문을 입력해 주세요.",
    PASSWORD: "영문, 숫자, 특수문자 포함하여 8자에서 20자 이내로 입력해 주세요.",
    PASSWORD_CAPS_LOCK: "CapsLock이 켜져 있습니다.",
    CONFIRM_PASSWORD: "비밀번호를 확인해 주세요.",
    PHONE_NUMBER: "국제 형식의 휴대전화 번호를 입력해 주세요. (e.g. +821012345678)",
    REQUIRED: "필수 정보입니다.",
    URL: "http(s)를 포함한 정확한 URL을 입력해 주세요.",
    TIMEOUT_EMAIL_AUTHENTICATION_CODE:
      "이메일 인증 코드 유효시간이 초과하였습니다. 이메일 인증 코드를 재발급해 주세요.",
    PULL_REQUEST_URL:
      "정확한 풀 리퀘스트 주소를 입력해 주세요. (e.g. https://github.com/woowacourse-precourse/java-baseball/pull/1)",
    REPOSITORY_URL:
      "정확한 저장소 주소를 입력해 주세요. (e.g. https://github.com/javajigi/java-baseball-javajigi)",
    GITHUB_USERNAME:
      "GitHub 사용자 이름 정책에 따라 영문, 숫자, 하이픈 조합을 사용하여 최대 39자까지 가능합니다.",
    BIRTHDAY: "유효하지 않은 날짜입니다. 정확한 날짜를 입력해 주세요.",
    BIRTHDAY_IS_NOT_OVER_14: "만 14세 이상만 회원 가입이 가능합니다.",
  },
  API: {
    ALREADY_REGISTER: "You have already applied.\n이미 지원한 이력이 있습니다.",
    FETCHING_MY_APPLICATIONS:
      "Failed to load your application information.\n지원 정보를 불러오지 못했습니다.",
    FETCHING_MY_APPLICATION: "Failed to load your application form.\n지원서를 불러오지 못했습니다.",
    JOIN_FAILURE:
      "Failed to sign up. Please try again later.\n회원 가입에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    LOGIN_FAILURE: "Please check your email and password.\n이메일 또는 비밀번호를 확인해 주세요.",
    EDIT_FAILURE:
      "Failed to update. Please try again later.\n변경에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    TOKEN_EXPIRED:
      "Please sign up or log in to securely manage your personal information.\n안전한 개인 정보 관리를 위해 로그인 또는 회원 가입을 해주세요.",
    FETCHING_MEMBER_INFO: "Failed to load your information.\n내 정보를 불러오지 못했습니다.",
    NOT_AUTHENTICATED: "Please complete your email verification.\n이메일 인증을 완료해 주세요.",
    ALREADY_EXIST_EMAIL: "This email is already registered.\n이미 가입된 이메일입니다.",
    INVALID_AUTHENTICATION_CODE:
      "The verification code does not match.\n인증 코드가 일치하지 않습니다.",
    SUBMIT_ASSIGNMENT: "Failed to submit the assignment.\n과제를 제출할 수 없습니다.",
    SUBMIT_APPLICATION:
      "The entered information is invalid. Please check again.\n" +
      "입력한 정보가 올바르지 않습니다. 다시 확인해 주세요.",
    FIND_PASSWORD:
      "The entered information is invalid. Please check again.\n" +
      "입력한 정보가 올바르지 않습니다. 다시 확인해 주세요.",
    EDIT_PASSWORD:
      "The entered information is invalid. Please check again.\n입력한 정보가 올바르지 않습니다. 다시 확인해 주세요.",
    LOAD_APPLICATION_FORM:
      "Failed to load the application form. Please try again later.\n" +
      "지원서를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
    SAVE_APPLICATION_FORM:
      "Failed to save the application form. Please try again later.\n" +
      "지원서를 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.",
    LOAD_AGREEMENT:
      "Failed to load the agreement. Please try again later.\n" +
      "동의서를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
    SUCCEED_TO_WITHDRAW: "회원탈퇴가 완료되었습니다. 메인으로 돌아갑니다.",
    FAILED_TO_WITHDRAW_OTHER_REASONS: "회원탈퇴에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    FAILED_TO_WITHDRAW_BECAUSE_OF_PASSWORD: "입력된 정보가 올바르지 않습니다. 다시 확인해 주세요.",
  },
  ACCESS: {
    REQUIRED_LOGIN: "Login is required.\n로그인이 필요합니다.",
  },
  HOOKS: {
    CANNOT_FIND_FORM_CONTEXT: "FormContext가 존재하지 않습니다.",
    CANNOT_FIND_RECRUITMENT_CONTEXT: "recruitmentContext가 존재하지 않습니다",
    CANNOT_FIND_TOKEN_CONTEXT: "TokenContext가 존재하지 않습니다",
    CANNOT_FIND_MEMBER_INFO_CONTEXT: "MemberInfoContext가 존재하지 않습니다",
    CANNOT_FIND_MODAL_CONTEXT: "ModalContext가 존재하지 않습니다",
  },
} as const;

export const SUCCESS_MESSAGE = {
  API: {
    CHANGE_PASSWORD:
      "Your password has been changed. Please log in again.\n" +
      "비밀번호가 변경되었습니다. 다시 로그인해 주세요.",
    SUBMIT_APPLICATION: "Your application has been submitted.\n정상적으로 제출되었습니다.",
    SUBMIT_ASSIGNMENT: "Your assignment has been submitted.\n정상적으로 제출되었습니다.",
    SAVE_APPLICATION: "Your application has been saved.\n정상적으로 저장되었습니다.",
    EDIT_MY_PAGE: "Your information has been updated.\n정상적으로 변경되었습니다.",
  },
} as const;

export const CONFIRM_MESSAGE = {
  RESET_APPLICATION: "Are you sure you want to reset?\n정말 초기화하시겠습니까?",
  CANCEL_ASSIGNMENT_SUBMIT:
    "Are you sure you want to cancel? Your progress will not be saved.\n" +
    "정말 취소하시겠습니까? 작성하신 내용이 저장되지 않습니다.",
} as const;

export const PUBLIC_PULL_REQUEST_TOOLTIP_MESSAGE = [
  "예제 테스트 결과는 실제 채점 결과와 관련이 없습니다.",
  "예제 테스트를 실행하려면 과제 제출물을 제출해야 합니다.",
  "제출 마감일이 지난 후에는 예제 테스트를 실행할 수 없습니다.",
  "예제 테스트를 실행하지 않더라도 제출한 풀 리퀘스트를 기준으로 채점이 이루어집니다.",
] as const;

export const PRIVATE_REPOSITORY_TOOLTIP_MESSAGE = [
  "예제 테스트 결과는 실제 채점 결과와 관련이 없습니다.",
  "예제 테스트를 실행하려면 과제 제출물을 제출해야 합니다.",
  "제출 마감일이 지난 후에는 예제 테스트를 실행할 수 없습니다.",
  "예제 테스트를 실행하지 않더라도 제출한 저장소의 main 브랜치를 기준으로 채점이 이루어집니다.",
] as const;
